import { useState } from 'react';

export default function PasswordInput({ className, ...props }) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <input {...props} type={show ? 'text' : 'password'} className={className} />
      <button
        type="button"
        onClick={() => setShow((visible) => !visible)}
        aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
        className="absolute right-2.5 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-md text-slate-500 transition-colors hover:text-slate-700"
      >
        <span className="material-symbols-outlined text-[18px]">{show ? 'visibility_off' : 'visibility'}</span>
      </button>
    </div>
  );
}